import { render, staticRenderFns } from "./ASignDialogBox.vue?vue&type=template&id=64a35624&scoped=true&"
import script from "./ASignDialogBox.vue?vue&type=script&lang=js&"
export * from "./ASignDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a35624",
  null
  
)

export default component.exports